import { render, staticRenderFns } from "./AnswerButton.vue?vue&type=template&id=c4c7bb7c&scoped=true"
import script from "./AnswerButton.vue?vue&type=script&lang=js"
export * from "./AnswerButton.vue?vue&type=script&lang=js"
import style0 from "./AnswerButton.vue?vue&type=style&index=0&id=c4c7bb7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c7bb7c",
  null
  
)

export default component.exports